import { createContext, useContext, useState } from "react";

const ThemeContext = createContext<any>({});
export const ThemeProvider = ({ children }) => {
    const [Theme, setTheme] = useState(0);

    return (
        <ThemeContext.Provider value={{ Theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    )
}
const useThemeProvider = () => useContext(ThemeContext);

export default useThemeProvider;